import { withGalleryCardCarouselProps } from 'viewModel/productPage/GalleryCardCarousel/withGalleryCardCarouselProps';
import GalleryCardCarousel from 'components/ProductPage/GalleryCardCarousel/GalleryCardCarousel';

export default withGalleryCardCarouselProps(GalleryCardCarousel);
